/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/camelcase */
import PageTitle from 'components/PageTitle';
import i18n from 'i18n';
import { newEnvironmentRequest } from 'modules/environments/actions';
import { EnvironmentFields } from 'modules/environments/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Button from 'components/Button';
import { modalOpen, modalClose } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import { Grid } from '@material-ui/core';
import { CompanyData, PartnerData } from 'modules/authenticate/interfaces';
import FormEnvironment from '../Form';

interface Props {
  companySelected: CompanyData | null;
  isLoading: boolean;
  partnerSelected: PartnerData | null;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  newEnvironmentRequest: (values) => void;
}

const NewEnvironments = ({
  companySelected,
  isLoading,
  partnerSelected,
  modalOpen,
  modalClose,
  newEnvironmentRequest,
}: Props) => {
  const handleSubmit = (values: EnvironmentFields) => {
    if (values.provider.type === 'aws') {
      values.provider.default_zone = '';
    }
    modalOpen({
      title: i18n.t('ENVIRONMENTS_PAGE.CREATE_ENVIRONMENT_KEY'),
      content: i18n.t('ENVIRONMENTS_PAGE.WANT_CREATE_ENVIRONMENTS_KEY'),
      footer: (
        <Grid justify="flex-end">
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              newEnvironmentRequest(values);
              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  const hasCompanyOrPartner = companySelected && partnerSelected;

  return (
    <Grid container>
      <Grid item xs={12}>
        <PageTitle
          title={i18n.t('ENVIRONMENTS_PAGE.CREATE_ENVIRONMENT_KEY')}
          subtitle={
            hasCompanyOrPartner &&
            `${i18n.t(
              'ENVIRONMENTS_PAGE.CREATE_ENVIRONMENT_SUBTITLE_KEY.COMPANY_NAME_SUBTITLE_KEY'
            )} ${companySelected?.name} > ${partnerSelected?.name}`
          }
        />
      </Grid>

      <FormEnvironment isLoading={isLoading} onSubmit={handleSubmit} />
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, partnerSelected },
  environments: { isLoading },
}: ApplicationState) => ({
  isLoading,
  companySelected,
  partnerSelected,
});

export default connect(mapStateToProps, {
  newEnvironmentRequest,
  modalOpen,
  modalClose,
})(NewEnvironments);
